"use client";

import { useEffect } from "react";
import { useSession } from "next-auth/react";
import { applyTheme, getClientThemeFallback, type ThemeMode } from "@/lib/theme";

export default function ThemeController() {
  const { data } = useSession();

  useEffect(() => {
    const pref = data?.user?.themePreference;
    const theme: ThemeMode =
      pref === "light" || pref === "dark" ? pref : getClientThemeFallback();
    applyTheme(theme);
  }, [data?.user?.themePreference]);

  return null;
}
